<template>
    <vs-popup classContent="popup-example" :title="translate('AddKey')" :active.sync="popUps.popupAddActive">
      <div class="vx-row mb-6" v-if="providers.length>0">
        <div class="vx-col w-full">
          <vs-select
              @change="getSubProvider()"
              placeholder="Select provider"
              autocomplete
              class="selectExample w-full"
              label="Providers"
              v-model="formParams.provider"
              >
              <vs-select-item :key="index" :value="item.deal" :text="item.deal" v-for="(item,index) in providers" />
          </vs-select>
          </div>
      </div>
      <div class="vx-row mb-6" v-if="subProviders.length>0">
        <div class="vx-col w-full">
          <vs-select
              @change="getSubProvider()"
              placeholder="Select sub- provider"
              autocomplete
              class="selectExample w-full"
              label="Sub-Providers"
              v-model="formParams.subProvider"
              >
              <vs-select-item :key="index" :value="item.sub_provider" :text="item.sub_provider" v-for="(item,index) in subProviders" />
          </vs-select>
          </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Name')" v-model="formParams.pageName" :readonly="formParams.formType==='edit'" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Title')" v-model="formParams.pageTitle" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('Description')" v-model="formParams.pageDescription" />
        </div>
      </div>      
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="submitForm()" color="primary" type="filled">{{translate('Save')}}</vs-button>
        </div>
      </div>
    </vs-popup>
</template>
<script>
import axios from "@/axios.js"
export default {
    props:['closePopups','formParams','popUps','openAlert'],
    data() {
        return {
          providers:[],
          subProviders:[]
        }
    },
    watch: {
    'popUps.popupAddActive'(val) {
      if(val===true && this.providers.length===0)
        this.getProviders();
    }
  },
    methods:{
      getSubProvider: function(){
        let that = this;
        this.$vs.loading();
        axios.get("https://crm.evblock.com/api/lists?sub-provider="+this.formParams.provider)
        .then((response) => {
          that.$vs.loading.close();
          that.subProviders.splice(0);
          if(response.data.length===0)
            return false;
          for(let i in response.data){
            const obj = JSON.parse(response.data[i].object);
            that.subProviders.push(obj);
          }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
      },
      getProviders: function(){
        let that = this;
        this.$vs.loading();
        axios.get("https://crm.evblock.com/api/lists?providers")
        .then((response) => {
          that.$vs.loading.close();
          that.subProviders.splice(0);
          for(let i in response.data){
            const obj = JSON.parse(response.data[i].object);
            that.providers.push(obj);
          }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
      },
      translate: function(key){
        return this.$t(key);
      },
      submitForm: function(){
        let that = this;
        this.$validator.validateAll().then(result => {
          if(result) {
            if(that.formParams.formType=='add')
              that.addData();
            else
              that.updateData();
          }
        })
      },
      addData: function(){
        let that = this;
        this.$vs.loading();
        axios.post("https://crm.evblock.com/api/blog",this.formParams)
        .then((data) => {
          that.$vs.loading.close();
          if(data.data.success){
            that.closePopups();
            that.openAlert('success','Success');
            that.componentKey++;
          } else{
            that.openAlert('danger','Failed',data.data.Message);
          }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    updateData: function(){
      let that = this;
      this.$vs.loading();
      axios.put("https://crm.evblock.com/api/blog",this.formParams)
      .then((data) => {
        that.$vs.loading.close();
        if(data.data.success){
          that.closePopups();
          that.openAlert('success','Success');
          that.componentKey++;
        } else{
          that.openAlert('danger','Failed',data.data.Message);
        }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
    },
    }
}
</script>